class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        initIconSliderSwiper();
      },
      { once: true }
    );

    
    document.body.classList.add('overflow-hidden');
    $('.phase_select_drawer_outer').removeClass('open');
    $('.phase_select_drawer_outer').find('.phase_select_tabs_wrapper_content_tabbed').removeClass('show_tab').siblings().addClass('show_tab');
    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
      //     if($('body').hasClass('temp_product')){
      //       $(".product__info-container .icon_slider_cart_drawer").flickity('destroy');
      // $(".product__info-container .icon_slider_cart_drawer").flickity({
      //   wrapAround: true,
      //   groupCells: false,
      //   autoPlay: 5000,
      //   prevNextButtons: false,
      //   pageDots: false,
      //   selectedAttraction: 0.009,
      //   friction: 0.15
      // });
      // }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
 
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

/* ─────────────────────────────────────────────────────────────
   ROBUST renderContents
   Replaces the original to:
   1. Remove is-empty from the cart-drawer element itself
   2. Gracefully handle missing/broken sections data
   3. Fallback-fetch sections from the server when needed
   4. Always call open() — even on failure
───────────────────────────────────────────────────────────── */
CartDrawer.prototype.renderContents = function (parsedState) {
  this.classList.remove('is-empty');

  const self = this;
  const doOpen = () => setTimeout(() => self.open());

  // Replace .drawer__inner content with the fresh section render.
  // Using this.querySelector('.drawer__inner') instead of document.querySelector('#CartDrawer')
  // avoids any querySelector failure if the section HTML structure differs.
  const applyInner = (sectionHtml) => {
    if (!sectionHtml) return false;
    try {
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const srcInner = doc.querySelector('.drawer__inner');
      const destInner = self.querySelector('.drawer__inner');
      if (!srcInner || !destInner) return false;
      destInner.innerHTML = srcInner.innerHTML;
      return true;
    } catch (_) {
      return false;
    }
  };

  const applyBubble = (bubbleHtml) => {
    if (!bubbleHtml) return;
    try {
      const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const src = doc.querySelector('.shopify-section');
      const dest = document.getElementById('cart-icon-bubble');
      if (src && dest) dest.innerHTML = src.innerHTML;
    } catch (_) {}
  };

  const sectionHtml = parsedState && parsedState.sections && parsedState.sections['cart-drawer'];

  if (sectionHtml) {
    // Fast path: /cart/add response already includes rendered section HTML
    if (parsedState.id) this.productId = parsedState.id;
    applyInner(sectionHtml);
    initCrossSellSwiper();
    applyBubble(parsedState.sections && parsedState.sections['cart-icon-bubble']);
    doOpen();
  } else {
    // Fallback: sections not in response (e.g. cart-notification was primary cart target)
    // Fetch the section fresh then open
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '?section_id=cart-drawer')
      .then((r) => r.text())
      .then((html) => { applyInner(html); initCrossSellSwiper(); })
      .catch(() => {})
      .finally(doOpen);
  }
};

/* ─────────────────────────────────────────────────────────────
   AUTO-OPEN via pubsub (secondary path)
   product-form.js publishes PUB_SUB_EVENTS.cartUpdate with
   { source:'product-form', cartData: <addResponse> }
   cartData has the sections; pass it (not the wrapper object).
───────────────────────────────────────────────────────────── */
(function cartDrawerAutoOpen() {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (state) => {
    if (state.source !== 'product-form') return;

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    // state.cartData is the raw /cart/add response (has .sections)
    const parsedState = state.cartData || state;

    const quickAddModal = document.querySelector('quick-add-modal');
    if (quickAddModal && quickAddModal.hasAttribute('open')) {
      document.body.addEventListener(
        'modalClosed',
        () => setTimeout(() => cartDrawerEl.renderContents(parsedState)),
        { once: true }
      );
    } else {
      cartDrawerEl.renderContents(parsedState);
    }
  });
})();

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ─────────────────────────────────────────────────────────────
   QUANTITY INPUT  (− / + buttons)
   Defines quantity-input only if global.js hasn't already.
───────────────────────────────────────────────────────────── */
if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.quantity__input');
      if (!this.input) return;
      this.changeEvent = new Event('change', { bubbles: true });
      this.querySelectorAll('button').forEach((btn) =>
        btn.addEventListener('click', this._onClick.bind(this))
      );
    }

    _onClick(event) {
      event.preventDefault();
      const step = parseInt(this.input.step) || 1;
      const min  = parseInt(this.input.min)  || 0;
      const max  = this.input.max ? parseInt(this.input.max) : Infinity;
      let val    = parseInt(this.input.value) || 0;

      if (event.currentTarget.name === 'minus') {
        val = Math.max(min, val - step);
      } else {
        val = Math.min(max, val + step);
      }
      this.input.value = val;
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-input', QuantityInput);
}

/* ─────────────────────────────────────────────────────────────
   CROSS-SELL CAROUSEL  – Swiper
───────────────────────────────────────────────────────────── */
function initCrossSellSwiper() {
  if (typeof Swiper === 'undefined') { setTimeout(initCrossSellSwiper, 150); return; }
  document.querySelectorAll('.crosssell-carousel.swiper').forEach((el) => {
    if (el.swiper) return;
    const wrapper = el.closest('.crosssell-wrapper');
    new Swiper(el, {
      slidesPerView: 1.41,
      spaceBetween: 8,
      grabCursor: true,
      freeMode: true,
      navigation: wrapper ? {
        prevEl: wrapper.querySelector('.crosssell-arrow--prev'),
        nextEl: wrapper.querySelector('.crosssell-arrow--next'),
      } : false,
    });
  });
}


document.addEventListener('DOMContentLoaded', initCrossSellSwiper);

// Add-to-cart from cross-sell card
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.crosssell-card__cta');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.classList.add('loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
  })
    .then((r) => {
      if (!r.ok) throw new Error('add-to-cart failed');
      return fetch(`/?sections=cart-drawer,cart-icon-bubble`);
    })
    .then((r) => r.json())
    .then((sections) => {
      // Re-render drawer inner only (overlay is outside #CartDrawer and unaffected)
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const inner = doc.querySelector('.drawer__inner');
        if (inner) drawerEl.querySelector('.drawer__inner').innerHTML = inner.innerHTML;
        initCrossSellSwiper();
      }
      // Re-render cart bubble
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const sec = doc2.querySelector('.shopify-section');
        if (sec) bubble.innerHTML = sec.innerHTML;
      }
    })
    .catch((err) => console.error('[CrossSell] add-to-cart error:', err))
    .finally(() => {
      btn.disabled = false;
      btn.classList.remove('loading');
    });
});

/* ─────────────────────────────────────────────────────────────
   INJECT CSS CUSTOM PROPERTIES from theme settings
   (background + overlay colors/opacity set via inline style
    on :root so pure-CSS vars work without Liquid in JS)
───────────────────────────────────────────────────────────── */
(function applyCartDrawerCSSVars() {
  const root = document.documentElement;
  const bgEl  = document.querySelector('[data-cart-drawer-bg]');
  const ovEl  = document.querySelector('[data-cart-overlay-color]');
  const opEl  = document.querySelector('[data-cart-overlay-opacity]');
  if (bgEl) root.style.setProperty('--cart-drawer-bg', bgEl.dataset.cartDrawerBg);
  if (ovEl) root.style.setProperty('--cart-overlay-color', ovEl.dataset.cartOverlayColor);
  if (opEl) root.style.setProperty('--cart-overlay-opacity', parseFloat(opEl.dataset.cartOverlayOpacity) / 100);
})();

/* ─────────────────────────────────────────────────────────────
   ICON SLIDER – Swiper (1 slide, autoplay)
   Must init AFTER drawer is fully on-screen (transitionend),
   otherwise offsetWidth is 0 and Swiper sets ~33M px widths.
───────────────────────────────────────────────────────────── */
function initIconSliderSwiper() {
  if (typeof Swiper === 'undefined') { setTimeout(initIconSliderSwiper, 150); return; }
  document.querySelectorAll('.icon_slider_cart_drawer.swiper').forEach((el) => {
    if (el.swiper) { el.swiper.update(); return; }
    new Swiper(el, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  });
}



